import moment from "moment";
import { BONUS_TYPE_ID, FREQUENCY_ID } from "./../../../configs/constants";

export const months = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre"
].map((month, index) => ({ title: month, monthNb: index < 10 ? `0${index + 1}` : `${index + 1}` }));
export const quarters = ["Janvier - Mars", "Avril - Juin", "Juillet - Septembre", "Octobre - Décembre"].map(
  (quarter, index) => ({
    title: quarter,
    quarterNb: index * 3 + 1 < 10 ? `0${index * 3 + 1}` : `${index * 3 + 1}`
  })
);

export const bonusTypes = [
  { label: "Normales mensuelles", type: BONUS_TYPE_ID.REGULAR, frequency: FREQUENCY_ID.MONTHLY },
  { label: "Normales trimestrielles", type: BONUS_TYPE_ID.REGULAR, frequency: FREQUENCY_ID.QUARTERLY },
  { label: "Exceptionnelles", type: BONUS_TYPE_ID.EXTRA, frequency: null }
];

export const extractRegularBonus = (bonuses, monthNb, user_id) =>
  bonuses
    .filter(
      b =>
        b.user_id === user_id &&
        b.type_id === BONUS_TYPE_ID.REGULAR &&
        b.frequency_id === FREQUENCY_ID.MONTHLY &&
        moment(b.start_date).format("MM") === monthNb
    )
    .map(bonus => {
      const amount = bonus ? bonus.amount : null;
      return amount !== undefined && amount !== null ? amount : "N/C";
    })
    .join(" + ");

export const extractQuaterlyBonuses = (bonuses, quarterNb, user_id) =>
  bonuses
    .filter(
      b =>
        b.user_id === user_id &&
        b.type_id === BONUS_TYPE_ID.REGULAR &&
        b.frequency_id === FREQUENCY_ID.QUARTERLY &&
        moment(b.start_date).format("MM") === quarterNb
    )
    .map(bonus => {
      const amount = bonus ? bonus.amount : null;
      return amount !== undefined && amount !== null ? amount : "N/C";
    })
    .join(" + ");

export const extractExtraBonus = (bonuses, monthNb, user_id) => {
  return bonuses
    .filter(
      b => b.user_id === user_id && b.type_id === BONUS_TYPE_ID.EXTRA && moment(b.start_date).format("MM") === monthNb
    )
    .map(bonus => {
      const amount = bonus ? bonus.amount : null;
      return amount !== undefined && amount !== null ? amount : "N/C";
    })
    .join(" + ");
};



// WEBPACK FOOTER //
// src/containers/admin/premium/BonusesHistory.utils.js